<div class="ops-page">
  <div class="ops-header">
    <div>
      <div class="eyebrow">Supervisor</div>
      <h1>Operational Analytics</h1>
    </div>
    <div class="header-actions">
      <input type="date" [(ngModel)]="fromDate" (change)="load()" />
      <input type="date" [(ngModel)]="toDate" (change)="load()" />
      <button type="button" class="text-btn" (click)="downloadCsv()">
        <span class="material-icons">download</span>CSV
      </button>
      <button type="button" class="icon-btn" (click)="load()" title="Refresh">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <div class="empty-state" *ngIf="!report">
    <span class="material-icons">analytics</span>
    <strong>No report data loaded</strong>
  </div>

  <ng-container *ngIf="report">
    <div class="metric-grid">
      <div class="metric-card">
        <span class="material-icons">call</span>
        <div>
          <strong>{{ report.callsToday }}</strong>
          <small>Calls today</small>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-icons">timer</span>
        <div>
          <strong>{{ fmtSecs(report.avgHandleSeconds) }}</strong>
          <small>Avg handle</small>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-icons">pause_circle</span>
        <div>
          <strong>{{ fmtSecs(report.avgHoldSeconds) }}</strong>
          <small>Avg hold</small>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-icons">task_alt</span>
        <div>
          <strong>{{ report.firstCallResolution.pct }}%</strong>
          <small>FCR ({{ report.firstCallResolution.count }})</small>
        </div>
      </div>
      <div class="metric-card">
        <span class="material-icons">phone_callback</span>
        <div>
          <strong>{{ report.callbacks.completionPct }}%</strong>
          <small>Callback completion</small>
        </div>
      </div>
    </div>

    <div class="report-grid">
      <section class="report-panel">
        <h2>Dispositions</h2>
        <div class="bar-row" *ngFor="let item of top(report.dispositions)">
          <div class="bar-meta">
            <span>{{ item.label }}</span>
            <strong>{{ item.count }}</strong>
          </div>
          <div class="bar-track"><div class="bar-fill" [style.width.%]="item.pct"></div></div>
          <small>{{ item.pct }}%</small>
        </div>
      </section>

      <section class="report-panel">
        <h2>Call Reasons</h2>
        <div class="bar-row" *ngFor="let item of top(report.callReasons)">
          <div class="bar-meta">
            <span>{{ item.label }}</span>
            <strong>{{ item.count }}</strong>
          </div>
          <div class="bar-track"><div class="bar-fill alt" [style.width.%]="item.pct"></div></div>
          <small>{{ item.pct }}%</small>
        </div>
      </section>

      <section class="report-panel">
        <h2>Sources</h2>
        <div class="bar-row" *ngFor="let item of top(report.sources)">
          <div class="bar-meta">
            <span>{{ item.label }}</span>
            <strong>{{ item.count }}</strong>
          </div>
          <div class="bar-track"><div class="bar-fill source" [style.width.%]="item.pct"></div></div>
          <small>{{ item.pct }}%</small>
        </div>
      </section>

      <section class="report-panel">
        <h2>Queues</h2>
        <div class="bar-row" *ngFor="let item of top(report.queues)">
          <div class="bar-meta">
            <span>{{ item.label }}</span>
            <strong>{{ item.count }}</strong>
          </div>
          <div class="bar-track"><div class="bar-fill queue" [style.width.%]="item.pct"></div></div>
          <small>{{ item.pct }}%</small>
        </div>
      </section>

      <section class="report-panel">
        <h2>IVR Options</h2>
        <div class="bar-row" *ngFor="let item of top(report.ivrOptions)">
          <div class="bar-meta">
            <span>{{ item.label }}</span>
            <strong>{{ item.count }}</strong>
          </div>
          <div class="bar-track"><div class="bar-fill ivr" [style.width.%]="item.pct"></div></div>
          <small>{{ item.pct }}%</small>
        </div>
      </section>

      <section class="report-panel">
        <h2>Hang-up Party</h2>
        <div class="bar-row" *ngFor="let item of top(report.hangupParties)">
          <div class="bar-meta">
            <span>{{ item.label }}</span>
            <strong>{{ item.count }}</strong>
          </div>
          <div class="bar-track"><div class="bar-fill hangup" [style.width.%]="item.pct"></div></div>
          <small>{{ item.pct }}%</small>
        </div>
      </section>
    </div>
  </ng-container>
</div>
